export { default } from './QuotationDisplay';



// WEBPACK FOOTER //
// ./app/components/shared/UGC/QuotationDisplay/index.js